import { useMutation } from 'hooks/useMutation'
import { useQueryClient } from 'hooks/useQueryClient'

import {
  acceptMembershipRequestForUserId,
  declineMembershipRequestByUserIdAndProgramId,
} from 'utils/queries/membershipRequests'

export const useMembershipRequest = ({
  userId,
  programId,
}: {
  userId?: string
  programId?: string
}) => {
  const queryClient = useQueryClient()

  const acceptMembershipRequest = useMutation(
    async () => {
      if (!userId || !programId) throw new Error('Error accepting membership request')
      await acceptMembershipRequestForUserId(userId as string, programId as string)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['membershipRequests'])
        queryClient.invalidateQueries(['subscriptions'])
      },
    },
  )

  const declineMembershipRequest = useMutation(
    async () => {
      if (!userId || !programId) throw new Error('Error declining membership request')
      await declineMembershipRequestByUserIdAndProgramId(userId as string, programId as string)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['membershipRequests'])
      },
    },
  )

  return {
    acceptMembershipRequest,
    declineMembershipRequest,
    isLoading: acceptMembershipRequest.isLoading || declineMembershipRequest.isLoading,
  }
}
